import { useState, useRef } from "react";
import { Lock, Smartphone, Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Logo from "../../Images/Packky Logo Blue.svg";
import { Zap, BarChart3, Truck } from "lucide-react";
import useVolunteerLogin from "../../Hooks/useVolunteerLogin";
// import useLogin from "../../Sevices/useLogin";

export default function VolunteerLoginPage() {
  const [form, setForm] = useState({ mobile: "", password: "" });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setStep] = useState(1);
   const { login, loading } = useVolunteerLogin();
  // const { login, loading } = useLogin();
  const [showPassword, setShowPassword] = useState(false);

  const otpRefs = useRef([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      if (value && index < 5) otpRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const result = await login({
    mobile: form.mobile,
    password: form.password,
    step,
    otp: otp.join(""),
  });

  if (!result?.success) {
    alert(result?.message || "Something went wrong");
    return;
  }

  if (result?.nextStep === 2) {
    setStep(2);
    return;
  }


  if (result?.completed) {
    navigate("/volunteer", { replace: true });
    console.log("Login result:", result);
    console.log("Volunteer Token:", sessionStorage.getItem("volunteerToken"));


  }
};

//  const handleSubmit = async (e) => {
//     e.preventDefault();

//     const result = await login({
//       mobile: form.mobile,
//       password: form.password,
//       step,
//       otp: otp.join(""),
//     });

//     if (result.success) {
//       if (step === 1) {
//         setStep(2);
//       } else if (result.completed) {
//         setTimeout(() => {
//           navigate("/volunteer", { replace: true });
//         }, 100);
//       }
//     } else {
//       alert(result.message);
//     }
//   };

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-blue-100 to-yellow-50 flex items-center justify-center relative overflow-hidden p-2">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-20 w-32 h-32 bg-blue-300/40 rounded-full float delay-1000"></div>
          <div className="absolute top-40 right-32 w-24 h-24 bg-blue-300/30 rounded-full float delay-1500"></div>
          <div className="absolute bottom-32 left-40 w-20 h-20 bg-blue-300/30 rounded-full float delay-2000"></div>
          <div className="absolute bottom-20 right-20 w-28 h-28 bg-blue-300/30 rounded-full float delay-2500"></div>
        </div>

        {/* Main Container */}
        <div className="w-full max-w-6xl relative z-10 flex flex-col items-center">
          <div className="text-center mb-5">
            <div className="flex items-center justify-center mb-4">
              <img
                src={Logo}
                alt="Packky Logo"
                className="h-10 w-auto mx-auto"
              />
            </div>
            <h1 className="text-4xl font-bold text-gray-700 mb-2">
              Welcome to Volunteer Admin
            </h1>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-5 w-full max-w-lg border border-blue-100/30 mt-14 min-h-[400px]">
            <div className="flex justify-center mb-6">
              {/* User Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-24 h-24 rounded-full bg-blue-100 border-4 border-white shadow-lg flex items-center justify-center -mt-16 animate-bounce-slow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-12 h-12 text-blue-500"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2a5 5 0 100 10 5 5 0 000-10zm-7 18a7 7 0 0114 0H5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <form
              onSubmit={handleSubmit}
              className="space-y-8 h-full flex flex-col justify-between"
            >
              {/* Mobile Input */}
              <div className="relative group mt-6">
                <div className="absolute -top-7 left-0 flex items-center pointer-events-none">
                  <h2 className="text-start mb-4 text-lg font-bold">Mobile</h2>
                </div>
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Smartphone className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  placeholder="84049*****"
                  className="w-full pl-10 pr-4 py-3 bg-white/50 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 border mt-2 mb-2"
                />
              </div>

              {/* Password Input */}
              <div className="relative group">
                <div className="absolute -top-7 left-0 flex items-center pointer-events-none">
                  <h2 className="text-start text-lg mb-4 font-bold">
                    Password
                  </h2>
                </div>
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Password@1234"
                  className="w-full pl-10 pr-12 py-3 bg-white/50 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 border mt-2 mb-2"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  {!showPassword ? (
                    <EyeOff className="h-5 w-5" />
                  ) : (
                    <Eye className="h-5 w-5" />
                  )}
                </button>
              </div>

              {/* OTP Input */}
              {step === 2 && (
                <div className="relative group animate-slide-up">
                  <div className="absolute -top-6 left-0 flex items-center pointer-events-none">
                    <h2 className="text-start mt-2 text-lg font-bold"> OTP</h2>
                  </div>
                  <div className="flex justify-between gap-1 mt-4">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (otpRefs.current[index] = el)}
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(e, index)}
                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        className="w-12 h-12 text-center text-lg border border-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    ))}
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                // onClick={handleSubmit}
                disabled={loading}
                className="w-full bg-gradient-to-r from-blue-300 to-blue-300 hover:from-blue-300 hover:to-blue-300 text-slate-900 font-semibold py-3 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed bg-blue-300"
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-400"></div>
                    Processing...
                  </div>
                ) : step === 1 ? (
                  "Continue"
                ) : (
                  "Verify & Access Dashboard"
                )}
              </button>

              {step === 2 && (
                <div className="text-center text-gray-500 text-md">
                  We've sent a verification code to your mobile number
                </div>
              )}

              <div className="text-center text-gray-700 text-lg mt-6">
                © {new Date().getFullYear()} Packky. All rights reserved.
              </div>

              <div className="flex justify-between text-md font-bold mt-4 text-lg">
                <button
                  type="button"
                  className="text-blue-600 hover:text-blue-700 underline font-normal"
                >
                  Don't have an account?
                </button>
                <button
                  type="button"
                  className="text-blue-600 hover:text-blue-700 underline font-normal "
                >
                  Forgot password?
                </button>
              </div>
            </form>
          </div>

          <div className="grid grid-cols-2 sm:flex sm:flex-wrap justify-center gap-4 mt-10">
            <div className="rounded-full px-6 py-3 transition-all duration-300 bg-white hover:bg-blue-50 flex flex-col md:flex-row items-center gap-2 w-full sm:w-[45%] md:w-[22%]">
              <Zap className="w-6 h-6 text-blue-500" />
              <div className="text-sm text-slate-600">Lightning Fast</div>
            </div>

            <div className="rounded-full px-6 py-3 transition-all duration-300 bg-white hover:bg-blue-50 flex flex-col md:flex-row items-center gap-2 w-full sm:w-[45%] md:w-[22%]">
              <Lock className="w-6 h-6 text-blue-500" />
              <div className="text-sm text-slate-600">Ultra Secure</div>
            </div>

            <div className="rounded-full px-6 py-3 transition-all duration-300 bg-white hover:bg-blue-50 flex flex-col md:flex-row items-center gap-2 w-full sm:w-[45%] md:w-[22%]">
              <BarChart3 className="w-6 h-6 text-blue-500" />
              <div className="text-sm text-slate-600">Smart Analytics</div>
            </div>

            <div className="rounded-full px-6 py-3 transition-all duration-300 bg-white hover:bg-blue-50 flex flex-col md:flex-row items-center gap-2 w-full sm:w-[45%] md:w-[22%]">
              <Truck className="w-6 h-6 text-blue-500" />
              <div className="text-sm text-slate-600">Easy Pickup</div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .float {
          animation: float 6s ease-in-out infinite;
        }
        .delay-1000 { animation-delay: 1s; }
        .delay-1500 { animation-delay: 1.5s; }
        .delay-2000 { animation-delay: 2s; }
        .delay-2500 { animation-delay: 2.5s; }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </>
  );
}
